import { PlusCircle } from 'lucide-react';
import RideFiltersPanel from './RideFiltersPanel';
import RideStats from './RideStats';
import { DifficultyFilter, SkillFilter, RideTypeFilter, TimeFilter, MultiDayFilter } from '@/lib/types/core';
import { Ride, Point } from '@/lib/types/core';
import { TerrainType } from '@/lib/types/core/terrain';

interface RideHubSidebarProps {
  timeFilter: TimeFilter;
  setTimeFilter: (filter: TimeFilter) => void;
  difficultyFilter: DifficultyFilter;
  setDifficultyFilter: (filter: DifficultyFilter) => void;
  skillFilter: SkillFilter;
  setSkillFilter: (filter: SkillFilter) => void;
  rideTypeFilter: RideTypeFilter;
  setRideTypeFilter: (filter: RideTypeFilter) => void;
  multiDayFilter: MultiDayFilter;
  setMultiDayFilter: (filter: MultiDayFilter) => void;
  terrainFilter: TerrainType[];
  setTerrainFilter: (filter: TerrainType[]) => void;
  handleSubmitClick: () => void;
  rides: Ride[];
  setRideFilterLocation: (location: Point) => void;
}

const renderRideStats = (rides: Ride[]) => {
  return;
  return (
    <RideStats rides={rides} />
  )
}

const RideHubSidebar = ({
  timeFilter,
  setTimeFilter,
  difficultyFilter,
  setDifficultyFilter,
  skillFilter,
  setSkillFilter,
  rideTypeFilter,
  setRideTypeFilter,
  multiDayFilter,
  setMultiDayFilter,
  terrainFilter,
  setTerrainFilter,
  handleSubmitClick,
  rides,
  setRideFilterLocation,
}: RideHubSidebarProps) => {
  return (
    <aside className="lg:w-1/4">
      <RideFiltersPanel
        timeFilter={timeFilter}
        setTimeFilter={setTimeFilter}
        difficultyFilter={difficultyFilter}
        setDifficultyFilter={setDifficultyFilter}
        skillFilter={skillFilter}
        setSkillFilter={setSkillFilter}
        rideTypeFilter={rideTypeFilter}
        setRideTypeFilter={setRideTypeFilter}
        multiDayFilter={multiDayFilter}
        setMultiDayFilter={setMultiDayFilter}
        terrainFilter={terrainFilter}
        setTerrainFilter={setTerrainFilter}
        setRideFilterLocation={setRideFilterLocation}
      />
      
      <button
        onClick={handleSubmitClick}
        className="w-full btn-primary mb-6 flex items-center justify-center"
        aria-label="Submit a ride"
      >
        <PlusCircle size={18} className="mr-2" /> Submit a Ride
      </button>
      
      {renderRideStats(rides)}
    </aside>
  );
};

export default RideHubSidebar;
